module.exports = __webpack_public_path__ + "img/team.be32b6bd.png";